export class FormDashboard {
 public advancedsearchid: number;
  public formconfigid: number;
  public  userid: number;
  public  daterange: string;
  public  author: string;
  public  fieldsname: string;
  public advancedsearch: string;
  public  multiplewords: string;
  public  createdby: number;
  public createdon: string;
  public modifiedby: number;
  public  modifiedon: string;
  public active: number;
  public fieldscondition: string;
  public showforall: number;
}
